"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonControlsText = exports.ApplicationWorkflowStepProgress = void 0;
var React = require("react");
var csod = require("player-core");
var ViewSF_1 = require("./ViewSF");
var Text_1 = require("player-common-controls/controls/Text");
Object.defineProperty(exports, "CommonControlsText", { enumerable: true, get: function () { return Text_1.Text; } });
var ApplicationWorkflowStepProgress = (function (_super) {
    __extends(ApplicationWorkflowStepProgress, _super);
    function ApplicationWorkflowStepProgress(props) {
        var _this = _super.call(this, props) || this;
        _this.packageName = 'player-application-workflow';
        _this._renderView = _this._renderView.bind(_this);
        _this.viewSF = ViewSF_1.viewSF.apply(_this);
        _this.viewSF.constructor && _this.viewSF.constructor.apply(_this, arguments);
        _this._trackers = {};
        if (typeof csod.context.tracking !== 'undefined') {
            var monikerCallback_1 = function (moniker, eventName) {
                var evt = document.createEvent("Event");
                evt.initEvent("player-" + moniker + "-" + eventName, true, false);
                window.dispatchEvent(evt);
            };
            for (var reporter in csod.context.tracking) {
                var _loop_1 = function (moniker) {
                    var events = csod.context.tracking[reporter][moniker];
                    var _loop_2 = function (i, l) {
                        var event_1 = events[i];
                        var monikerKey = moniker + '.' + event_1;
                        if (typeof this_1._trackers[monikerKey] === 'undefined')
                            this_1._trackers[monikerKey] = function () { monikerCallback_1(moniker, event_1); };
                    };
                    for (var i = 0, l = events.length; i < l; i++) {
                        _loop_2(i, l);
                    }
                };
                var this_1 = this;
                for (var moniker in csod.context.tracking[reporter]) {
                    _loop_1(moniker);
                }
            }
        }
        return _this;
    }
    ApplicationWorkflowStepProgress.prototype.componentDidMount = function () {
        this.viewSF.mounted && this.viewSF.mounted.apply(this, arguments);
    };
    ApplicationWorkflowStepProgress.prototype.componentWillReceiveProps = function (nextProps) {
        this.viewSF.willReceiveProps && this.viewSF.willReceiveProps.apply(this, arguments);
    };
    ApplicationWorkflowStepProgress.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        if (this.viewSF.shouldUpdate)
            return this.viewSF.shouldUpdate.apply(this, arguments);
        else
            return true;
    };
    ApplicationWorkflowStepProgress.prototype.componentDidUpdate = function (prevProps, prevState) {
        this.viewSF.didUpdate && this.viewSF.didUpdate.apply(this, arguments);
    };
    ApplicationWorkflowStepProgress.prototype.componentWillUnmount = function () {
        this.viewSF.unmount && this.viewSF.unmount.apply(this, arguments);
    };
    ApplicationWorkflowStepProgress.prototype._proxyTrackEvent = function (moniker, eventID, eventName) {
        var params = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            params[_i - 3] = arguments[_i];
        }
        var args = [];
        for (var i = 3; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        var monikerKey = moniker + '.' + eventID;
        var monikerCallback = this._trackers[monikerKey] || function () { };
        return this._processEvent(eventName, args, 4, monikerCallback);
    };
    ApplicationWorkflowStepProgress.prototype._proxyEvent = function (eventName) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var args = [];
        for (var i = 1; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        return this._processEvent(eventName, args, 2, function () { });
    };
    ApplicationWorkflowStepProgress.prototype._processEvent = function (eventName, args, repeaterArgIndex, callback) {
        args = pushAndShiftArgs(args, repeaterArgIndex);
        if (typeof this.viewSF.events[eventName] === 'function') {
            var self_1 = this;
            return function proxy() {
                var combinedArgs = [].slice.call(arguments).concat(args);
                self_1.viewSF.events[eventName].apply(self_1, combinedArgs);
                csod.lastEventDate = new Date();
                callback();
            };
        }
        else {
            return function noFunc() {
                if (eventName) {
                    csod.logger.warn(eventName + ' is not a valid function. Please check for typos.');
                    csod.lastEventDate = new Date();
                }
                callback();
            };
        }
    };
    ApplicationWorkflowStepProgress.prototype._renderView = function () {
        var _this = this;
        var PlayerVisible = csod.engine.controls.Player.Visible;
        var PlayerSwitch = csod.engine.controls.Player.Switch;
        var root_handler = function () {
            return [
                React.createElement(Text_1.Text, { key: 0, text: (_this.state.hasOwnProperty('stepLocalizedText') ? _this.state.stepLocalizedText : _this.props.stepLocalizedText), color: "Muted", size: "Large" })
            ];
        };
        return root_handler();
    };
    ApplicationWorkflowStepProgress.prototype.render = function () {
        return (React.createElement("div", { className: "p-viewSF-applicationworkflowstepprogress" }, this._renderView()));
    };
    ApplicationWorkflowStepProgress.defaultProps = {
        currentPage: undefined, totalPages: undefined, StepText: null
    };
    return ApplicationWorkflowStepProgress;
}(React.Component));
exports.ApplicationWorkflowStepProgress = ApplicationWorkflowStepProgress;
function pushAndShiftArgs(args, repeaterArgIndex) {
    if (args[repeaterArgIndex] === 'repeaterArgs') {
        args.push(args.shift());
        args.push(args.shift());
        args.shift();
        pushAndShiftArgs(args, repeaterArgIndex);
    }
    return args;
}
if (!window["__LOCALES__"])
    window["__LOCALES__"] = {};
window["__LOCALES__"]["ApplicationWorkflowStepProgress"] = [];



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/ApplicationWorkflowStepProgress/ApplicationWorkflowStepProgress.js
// module id = 569
// module chunks = 0